import { ClockArrowIcon, NotificationActiveIcon } from '@common-web/icons';
import { Alert } from '@common-web/index';
import { strings } from '@constants/strings';
import { isCP } from '@utils/app-utils';
import { useSelector } from 'react-redux';
import tenantConfig from '../../../data/customizer/tenant-config';

const TaxValidationBanner = () => {
  const {
    tax_number,
    strn,
    govt_registration_status = 'pending',
  } = useSelector((state) => state?.userData?.userInfo?.userProfile?.store || {});

  const getAlertType = () => {
    const taxInfoAvailable = tax_number && strn;
    if (!taxInfoAvailable) {
      return {
        type: 'error',
        message: strings.tax_info_missing_message,
        title: strings.tax_info_missing_title,
        icon: <NotificationActiveIcon />,
        borderColor: 'var(--ant-red-3)',
        bgColor: 'var(--ant-red-1)',
        titleColor: 'var(--ant-red-7)',
      };
    }
    if (govt_registration_status === 'pending') {
      return {
        type: 'info',
        message: strings.tax_verification_in_process,
        title: strings.tax_verification_in_process_title,
        icon: <ClockArrowIcon />,
        borderColor: 'var(--ant-blue-3)',
        bgColor: 'var(--ant-blue-1)',
        titleColor: 'var(--ant-gray-6)',
      };
    }
    if (govt_registration_status === 'rejected') {
      return {
        type: 'error',
        message: strings.tax_verification_failed_message,
        title: strings.tax_verification_failed_title,
        icon: <NotificationActiveIcon />,
        borderColor: 'var(--ant-red-3)',
        bgColor: 'var(--ant-red-1)',
        titleColor: 'var(--ant-red-7)',
      };
    }
    return { type: 'warning', message: strings.tax_verification_in_process };
  };

  if (isCP() || govt_registration_status === 'verified' || !tenantConfig?.tax_verification_enabled) {
    return;
  }

  return (
    <Alert
      icon={getAlertType()?.icon}
      showIcon
      type={getAlertType()?.type}
      message={
        <span style={{ fontSize: 'var(--ant-font-size-heading-5)', fontWeight: 600, color: getAlertType().titleColor }}>
          {getAlertType()?.title}
        </span>
      }
      description={getAlertType()?.message}
      style={{
        '--ant-margin-xs': 0,
        '--ant-color-info-bg': getAlertType()?.bgColor,
        '--ant-color-info-border': getAlertType()?.borderColor,
        gap: 16,
        alignItems: 'center',
        position: 'sticky',
        top: 'calc(var(--ant-padding-lg) * -1)',
        zIndex: 9,
      }}
    />
  );
};

export default TaxValidationBanner;
